import { SET_MODAL, CLOSE_MODAL } from './actions';
const initialState = null;
function loadingReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_MODAL: {
            return payload;
        }
        case CLOSE_MODAL: {
            return null;
        }
        default: {
            return state;
        }
    }
}
export default loadingReducer;
